/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserDelegationUserGroup {
    getFixupPrototypeFunction() { return UserDelegationUserGroup.fixupPrototype; }

    static newInstance(model: Partial<UserDelegationUserGroup>): UserDelegationUserGroup {
        let obj = Object.assign(new UserDelegationUserGroup(), model);
        UserDelegationUserGroup.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserDelegationUserGroup>): UserDelegationUserGroup {
        if (!model) return null;
        return UserDelegationUserGroup.newInstance(<UserDelegationUserGroup> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserDelegationUserGroup) {
        if (!obj) return;

        models.UserDelegationUserGroup.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserDelegationUserGroup): boolean {
        Object.setPrototypeOf(obj, UserDelegationUserGroup.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * User group id
     */
    id: string;

    /**
     * User group name
     */
    name: string;

}
